// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:599px){.slide-enter-active[data-v-23605ed0],.slide-leave-active[data-v-23605ed0]{transition:all .3s ease-in-out}.slide-enter[data-v-23605ed0],.slide-leave-to[data-v-23605ed0]{transform:translateY(100%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
